import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@copro/api";
import { _3_DAYS } from "../../../constants/durations";
import { useSpace } from "../../../hooks/useSpace";
import { keys } from "./keys";

export interface GetProvidersParams {
  search?: string;
  page?: number;
  limit?: number;
}

async function fetchProviders(spaceId: string, params?: GetProvidersParams) {
  let query = apiClient
    .from('providers')
    .select(`*`)
    .eq('space_id', spaceId)
    .order('name', { ascending: true });

  if (params?.search) {
    query = query.ilike('name', `%${params.search}%`);
  }

  if (params?.page !== undefined && params?.limit !== undefined) {
    const from = (params.page - 1) * params.limit;
    const to = from + params.limit - 1;
    query = query.range(from, to);
  } else if (params?.limit !== undefined) {
    query = query.limit(params.limit);
  }

  const { data, error } = await query;

  if (error) {
    throw error;
  }

  return data;
}

export function useGetProviders(
  params?: GetProvidersParams,
  options?: { enabled?: boolean }
) {
  const { currentSpace } = useSpace();

  return useQuery({
    queryKey: keys.getProviders(currentSpace?.id ?? '', params),
    queryFn: () => fetchProviders(currentSpace!.id, params),
    enabled: (options?.enabled ?? true) && !!currentSpace?.id,
    staleTime: _3_DAYS,
  })
}

